type SignaturePreviewProps = {
  png: string;
  onClick?: () => void;
};

export function SignaturePreview({ png, onClick }: SignaturePreviewProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="w-full rounded border border-neutral-300 bg-white p-2 text-left"
    >
      {png ? (
        <img
          src={png}
          alt="Handtekening preview"
          className="max-h-40 w-full object-contain"
        />
      ) : (
        <div className="flex h-40 items-center justify-center text-sm text-neutral-400">
          Tik om te ondertekenen
        </div>
      )}
    </button>
  );
}
